import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateIncreasesMutation as UpdateIncreasesMutationType,
  UpdateIncreasesMutationVariables,
} from "./__generated__/UpdateIncreasesMutation";

const UpdateIncreasesMutation = loader("./UpdateIncreasesMutation.gql");

type UpdateIncreasesMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted?: (data: UpdateIncreasesMutationType) => void;
}) => ReactElement;

export const UpdateIncreasesMutationProvider: UpdateIncreasesMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateIncreasesMutationType, UpdateIncreasesMutationVariables>(
    UpdateIncreasesMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
